import { Fuel, Drill, BarChart3, Shield, Wrench } from 'lucide-react';
import { Product } from './types';

export const oilGasProducts: Product[] = [
  {
    id: 'drilling-operations-management',
    title: 'Drilling Operations Management System',
    subtitle: 'Comprehensive drilling oversight',
    description: 'Advanced drilling operations management with real-time monitoring, safety protocols, equipment tracking, and performance optimization.',
    icon: Drill,
    image: 'https://images.unsplash.com/photo-1516387938699-a93567ec168e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    features: [
      'Real-time drilling data',
      'Equipment monitoring',
      'Safety management',
      'Performance analytics',
      'Maintenance scheduling',
      'Cost tracking',
      'Compliance reporting',
      'Risk assessment'
    ],
    pricing: { setup: 68000, monthly: 3128 },
    color: 'from-gray-500 to-slate-600',
    businessTypes: ['#oil-gas', '#drilling', '#operations', '#safety', '#industrial']
  },
  {
    id: 'hse-management-system',
    title: 'HSE Management System',
    subtitle: 'Health, Safety & Environment',
    description: 'Comprehensive HSE management system with incident tracking, risk assessment, compliance monitoring, and safety training management.',
    icon: Shield,
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    features: [
      'Incident management',
      'Risk assessment',
      'Safety training',
      'Compliance tracking',
      'Environmental monitoring',
      'Audit management',
      'Reporting tools',
      'Mobile access'
    ],
    pricing: { setup: 42000, monthly: 1932 },
    color: 'from-green-500 to-emerald-600',
    businessTypes: ['#hse', '#safety', '#compliance', '#environment', '#training']
  },
  {
    id: 'pipeline-integrity-management',
    title: 'Pipeline Integrity Management',
    subtitle: 'Ensuring pipeline safety',
    description: 'Advanced pipeline integrity management with real-time monitoring, corrosion detection, risk assessment, and compliance reporting.',
    icon: Fuel,
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    features: [
      'Real-time monitoring',
      'Corrosion detection',
      'Risk assessment',
      'Compliance reporting',
      'Inspection scheduling',
      'Data analytics',
      'Geospatial mapping',
      'Emergency response'
    ],
    pricing: { setup: 55000, monthly: 2530 },
    color: 'from-red-500 to-orange-600',
    businessTypes: ['#oil-gas', '#pipeline', '#integrity', '#monitoring', '#safety']
  },
  {
    id: 'equipment-maintenance-optimization',
    title: 'Equipment Maintenance Optimization',
    subtitle: 'Maximizing equipment uptime',
    description: 'Comprehensive maintenance optimization with predictive analytics, maintenance scheduling, equipment tracking, and performance monitoring.',
    icon: Wrench,
    image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    features: [
      'Predictive analytics',
      'Maintenance scheduling',
      'Equipment tracking',
      'Performance monitoring',
      'Spare parts management',
      'Work order management',
      'Mobile access',
      'Reporting tools'
    ],
    pricing: { setup: 48000, monthly: 2208 },
    color: 'from-yellow-500 to-amber-600',
    businessTypes: ['#oil-gas', '#equipment', '#maintenance', '#optimization', '#analytics']
  },
  {
    id: 'production-data-analytics',
    title: 'Production Data Analytics Platform',
    subtitle: 'Insights for oil & gas',
    description: 'Advanced analytics platform for oil and gas production with real-time data visualization, performance dashboards, and predictive modeling.',
    icon: BarChart3,
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    features: [
      'Real-time data',
      'Performance dashboards',
      'Predictive modeling',
      'Data visualization',
      'Custom reporting',
      'Trend analysis',
      'Integration capabilities',
      'Mobile access'
    ],
    pricing: { setup: 58000, monthly: 2668 },
    color: 'from-blue-500 to-indigo-600',
    businessTypes: ['#oil-gas', '#production', '#analytics', '#data', '#visualization']
  }
];
